var _a;
import { Roles } from 'constants/accessControlList';
import { noteType } from 'constants/ehrNoteEnums';
import { useMemo } from 'react';
import pickBy from 'lodash/pickBy';
import { useToken } from 'shared/hooks';
import { noteTypeLabels } from 'constants/noteType';
import { overrideTokenRolesWithLDForTesting } from 'shared/features/rbac';
var typesForRoles = (_a = {},
    _a[Roles.CareProvider] = [noteType.providerUnscheduled],
    _a[Roles.CareNavigator] = [noteType.careNavigatorUnscheduled],
    _a[Roles.ClinicalManager] = [noteType.careNavigatorUnscheduled],
    _a[Roles.MedManager] = [noteType.medManagerUnscheduled],
    _a);
/**
 *
 * @returns Checks user role and populates corresponding unscheduled note type
 */
export var useNoteTypesForRole = function () {
    var scopes = (useToken() || { scopes: [] }).scopes;
    var roles = overrideTokenRolesWithLDForTesting(scopes);
    var noteTypesForRole = useMemo(function () {
        var types = [];
        /*
        re-enable if ever desired for roles to be reduced instead of first selected
        for (const role of roles) {
          types.push(
            ...(role in typesForRoles ? typesForRoles[role as keyof typeof typesForRoles] : [])
          );
        }
        */
        var roleWithTypes = roles.find(function (role) { return role in typesForRoles; });
        if (roleWithTypes) {
            types.push.apply(types, typesForRoles[roleWithTypes]);
        }
        return types;
    }, [roles]);
    var noteTypeLabelsForRole = pickBy(noteTypeLabels, function (_, key) {
        return noteTypesForRole.includes(key);
    });
    return { noteTypesForRole: noteTypesForRole, noteTypeLabelsForRole: noteTypeLabelsForRole };
};
